class AnimatedCounter extends HTMLElement {
  constructor() {
    super();
    this.target = parseInt(this.getAttribute('target') || '100', 10);
    this.duration = parseInt(this.getAttribute('duration') || '1500', 10);
    this.observer = null;
    this.hasAnimated = false;
    this.textContent = '0';
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.countUp();
            this.hasAnimated = true;
            this.observer.disconnect();
          }
        });
      },
      {
        threshold: 0.2
      }
    );
    this.observer.observe(this);
  }

  countUp() {
    const start = 0;
    const end = this.target;
    const duration = this.duration;
    const startTime = performance.now();

    const animateCount = (/** @type {number} */ currentTime) => {
      const elapsed = currentTime - startTime;
      let progress = Math.min(elapsed / duration, 1);
      let currentValue = Math.floor(progress * (end - start) + start);
      this.textContent = currentValue.toLocaleString();
      if(progress < 1) {
        requestAnimationFrame(animateCount);
      } else {
        this.textContent = end.toLocaleString();
      }
    };
    requestAnimationFrame(animateCount);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('animated-counter')) {
  customElements.define('animated-counter', AnimatedCounter);
}